var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"splash tw-flex tw-items-center tw-justify-center tw-w-full tw-bg-white tw-max-h-[80vh]"},[_c('img',{staticClass:"tw-w-[300px] lg:tw-w-[600px]",attrs:{"alt":"","src":`${_setup.uriResources}/storage/documents/${_setup.props.gif}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }